<template>
  <e-chart
    :header="`${documentTitle}`"
    :options="chartVolumeGarbageOptions"
    :series="chartVolumeGarbageSeries"
    class="item-large"
    chartId="garbageVolume"
    :chartRedirectParams="chartRedirectParams"
    :chartLoading="chartLoading"
    :chartError="chartError"
  >
    <template slot="chartHeader">
      <div class="default-select part-1-from-4">
        <e-select
          tabView="tab1"
          :model="fields"
          name="garbageVolumeYear"
          :options="chartYearOptions"></e-select>
      </div>
    </template>
  </e-chart>
</template>
<script>
  import chartsMixin from '../mixins/charts-mixin.js'

  export default {
    mixins: [chartsMixin],
    created () {
      this.fetchData()
    },
    watch: {
      'fields.garbageVolume.viewMode': {
        handler: function(v) {
          this.viewMode = v
          this.fetchData()
        }
      },
      'fields.garbageVolumeYear': 'fetchData'
    },
    computed: {
      viewMode: {
        get: function () {
          return this.$store.getters.charts.garbageVolume.viewMode
        },
        set: function (newValue) {
          this.$store.commit('charts', {garbageVolume: {viewMode: newValue}})
        },
      },
      getCurrentChartOptions () {
        return this.getChartOptions('garbageVolume')
      }
    },
    methods: {
      buildEndpoint () {
        return this.getEndpoint()({
          query: {
            year: this.fields.garbageVolumeYear,
            type: 'fkko',
            viewMode: this.viewMode
          }
        })
      },
      fetchData () {
        this.fetchChartData().then(r => {
          this.chartVolumeGarbageSeries = this.transform(r)
        })
      }
    }
  }
</script>
